export const readablePhoneNumber = (
  phoneNumber: string | null | undefined,
): string | null | undefined => {
  if (!phoneNumber) {
    return phoneNumber;
  }

  // Remove all non-digit characters
  const digits = phoneNumber.replace(/\D/g, "");

  switch (digits.length) {
    case 10: // Standard US number (1234567890)
      return digits.replace(/(\d{3})(\d{3})(\d{4})/, "$1-$2-$3");
    case 11: // US number with country code (11234567890)
      if (digits.startsWith("1")) {
        return digits.substring(1).replace(/(\d{3})(\d{3})(\d{4})/, "$1-$2-$3");
      }
      return digits;
    case 7: // Local number without area code
      return digits.replace(/(\d{3})(\d{4})/, "$1-$2");
    default:
      return digits;
  }
};
